import React from 'react';
import UploadedFileStates from './FileUploadStatesV2';
import { FileUploadContainerV2Props } from './interface';

const FileUploadContainer: React.FC<FileUploadContainerV2Props> = ({
  error,
  file,
  setFile,
  setError,
  showLoadingComponent,
  setShowLoadingComponent,
  handleDownloadClick,
  styles,
  supportedFile,
  isSampleFileAvailable,
  statesContainerClassName,
  errorContainerClassName,
  messageClassName
}) => {
  return (
    <>
      <UploadedFileStates
        error={error}
        file={file}
        setFile={setFile}
        setError={setError}
        showLoadingComponent={showLoadingComponent}
        setShowLoadingComponent={setShowLoadingComponent}
        supportedFile={supportedFile}
        handleDownloadClick={handleDownloadClick}
        styles={styles}
        isSampleFileAvailable={isSampleFileAvailable}
        statesContainerClassName={statesContainerClassName}
        errorContainerClassName={errorContainerClassName}
        messageClassName={messageClassName}
      />
    </>
  );
};

export default FileUploadContainer;
